import Type from 'me-view/lib/script/type'
import http from '@common/ExtendHttp'
import util from '@common/util'
import tools from 'me-view/lib/script/tools'
export default {
  /**
   * 加载服务端配置
   */
  async loadSystemConfig () {
    if (tools.isBlank(util.config)) {
      console.debug('loadSystemConfig - 本地缓存的配置信息为:', util.config)
      if (Type.isObject(util.config)) {
        return Promise.resolve(util.config)
      }
      console.debug('程序开始查询服务端配置信息...')
      util.config = await http.get('/security/config/system')
    }
  },

  async loadSystemDict () {
    if (tools.isBlank(util.systemDict)) {
      const data = await http.get('/security/dict/item/list')
      const systemDict = {}
      for (const item of (data || [])) {
        const dictValue = (item.dictValueList || []).flatMap(({ code, name }) => ({ value: code, label: name }))
        if (dictValue) {
          Reflect.set(systemDict, item.code, dictValue)
        }
      }
      util.systemDict = systemDict
    }
  },

  loadSystemButton () {
    http.post('/security/resource/system/button').then(data => {
      const buttons = {}
      data.forEach(b => {
        Reflect.set(buttons, b.menuUrl, b)
      })
      util.buttons = buttons
    })
  },

  async loadSystemPage () {
    const data = await http.post('/security/resource/system/page')
    const menus = {}
    data.forEach(b => {
      Reflect.set(menus, b.menuUrl, b)
    })
    util.menus = menus
  },
  async loginToken ({ source, token } = { }) {
    const userInfo = await http.post('/security/login/token', { source, token }, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
    if (util.config.systemVerifyButton) { this.loadSystemButton() }
    if (util.config.systemVerifyPage) { await this.loadSystemPage() }
    return userInfo
  },
  /**
   * 系统心跳
   */
  heartbeat () {
    // 执行心跳逻辑
    http.post('/security/auth/heartbeat')
      .then(() => {
        console.debug('auth.heartbeat -- 执行心跳时间：', new Date().getTime())
      })
      .catch((error) => {
        console.debug('auth.heartbeat -- error：', error)
      })
  }
}
